import type { SchemaSlotLayout } from '@cli-types/core-engine/schema.js'
import { isRecord } from '@cli-utils/shared.js'

export function isSchemaSlotLayout(value: unknown): value is SchemaSlotLayout {
  return isRecord(value)
}
